import React from "react";
import {
  Box,
  Typography,
  TextField,
  Alert,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import RateReviewIcon from "@mui/icons-material/RateReview";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import EmailIcon from "@mui/icons-material/Email";
import SelectorArchivos from "../../../../components/comun/selectorArchivos";

/**
 * Sección de nuevo comentario con selector de archivos y, en incidencias ya
 * existentes, el check para enviar el comentario por correo al cliente
 */
const SeccionComentarioNuevo = ({
  comentario,
  error,
  loading,
  onChange,
  onImagenesChange,
  puedeEnviarEmail,
  destinatarioEmail,
  enviarEmail,
  onEnviarEmailChange,
}) => {
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            mb: 1,
            color: "#495057",
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <RateReviewIcon sx={{ fontSize: 18 }} />
          Nuevo comentario *
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder="Escribe un comentario sobre la incidencia..."
          value={comentario}
          onChange={onChange}
          disabled={loading}
          inputProps={{ maxLength: 250 }}
          helperText={`${comentario.length}/250 caracteres`}
        />
        {error && (
          <Alert severity="error" sx={{ mt: 1, fontSize: 12 }}>
            {error}
          </Alert>
        )}
        {puedeEnviarEmail && (
          <FormControlLabel
            sx={{ mt: 0.5 }}
            control={
              <Checkbox
                size="small"
                checked={enviarEmail}
                onChange={(e) => onEnviarEmailChange(e.target.checked)}
                disabled={loading}
                sx={{ color: "#6c757d", "&.Mui-checked": { color: "#cc071e" } }}
              />
            }
            label={
              <Typography
                variant="body2"
                sx={{
                  fontSize: 13,
                  color: "#495057",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <EmailIcon sx={{ fontSize: 16 }} />
                Enviar el comentario por correo al cliente{destinatarioEmail ? ` (${destinatarioEmail})` : ""}
              </Typography>
            }
          />
        )}
      </Box>

      {/* Selector de archivos */}
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            mb: 1,
            color: "#495057",
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <AttachFileIcon sx={{ fontSize: 18 }} />
          Adjuntar imágenes (opcional)
        </Typography>
        <SelectorArchivos acumular={true} onFilesChange={onImagenesChange} />
      </Box>
    </>
  );
};

export default SeccionComentarioNuevo;
